import { auth } from '@/plugins/firebase';
import { onAuthStateChanged, signOut, User } from 'firebase/auth';
import { ActionContext } from 'vuex';
import { RootState } from '@/store/index';
import { AuthState } from '@/models/models'

const state: AuthState = {
    user: null,
};

const mutations = {
    setUser(state: AuthState, user: User) {
        state.user = user;
    },
    clearUser(state: AuthState) {
        state.user = null;
    }
}

const actions = {
    initAuth({ commit }: ActionContext<AuthState, RootState>) {
        onAuthStateChanged(auth, (user) => {
            if (user) {
                commit('setUser', user);
            } else {
                commit('clearUser');
            }
        });
    },
    async logOut({ commit }: ActionContext<AuthState, RootState>) {
        try {
            await signOut(auth);
            commit('clearUser');
        } catch (error) {
            console.error("Error signing out", error);
        }
    },
    setUser({ commit }: ActionContext<AuthState, RootState>, user: User) {
        commit('setUser', user);
    },
    clearUser({ commit }: ActionContext<AuthState, RootState>) {
        commit('clearUser');
    },
};

const getters = {
    isAuthenticated: (state: AuthState): boolean => !!state.user,
    user: (state: AuthState): User | null => state.user,
}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
}
